import { render, staticRenderFns } from "./BadgesRow.vue?vue&type=template&id=6966f160&"
import script from "./BadgesRow.vue?vue&type=script&lang=js&"
export * from "./BadgesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports